import * as types from './types';

const ageCheckPassedLocalStorage = () => sessionStorage.getItem("ageCheckAccepted");

const initialState = {
  ageCheckAccepted: ageCheckPassedLocalStorage()
};

const ageCheckReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.ACCEPT_AGE_CHECK: {
      sessionStorage.setItem("ageCheckAccepted", true);
      return { ...state, ageCheckAccepted: true };
    }
    default:
      return state;
  }
};

export default ageCheckReducer;